module.exports = __webpack_public_path__ + "img/img_liulan.4c336923.png";